import { render } from "./MatchItem.vue?vue&type=template&id=3e9b9c82"
import script from "./MatchItem.vue?vue&type=script&lang=js"
export * from "./MatchItem.vue?vue&type=script&lang=js"

import "./MatchItem.vue?vue&type=style&index=0&id=3e9b9c82&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__